/**
 * @param channels - array of {@link TrqkGapChannel} objects
 * @returns an array of all `channel_id`s that have `.include == true`
 */
export const getIncludedGapChannelIds = (
    channels: TrqkGapChannel[],
): string[] =>
    channels.reduce(
        (acc: string[], channel: Maybe<TrqkGapChannel>): string[] => {
            const include = channel?.include ?? false;
            const channelId = channel?.channel_id ?? null;

            if (include && channelId !== null) {
                acc.push(channelId);
            }

            return acc;
        },
        [],
    );
